import { z } from '@bonanza-social/toolkit/api';

export const InstantMetaGameTypeSchema = z.enum(['Wheel', 'Scratcher']);
export const DailyMetaGameTypeSchema = z.enum(['DailyScratcher', 'DailyWheel']);

export const MetaGameTypeSchema = z.union([
  InstantMetaGameTypeSchema,
  DailyMetaGameTypeSchema,
]);

export const RewardCountSchema = z.object({
  count: z.number(),
});

export const GetRewardsResponseSchema = z.object({
  metaGameRewards: z.object({
    Wheel: RewardCountSchema.optional(),
    Scratcher: RewardCountSchema.optional(),
  }),
});

export const GetLaunchUrlRequestSchema = z.object({
  prizeDelivery: MetaGameTypeSchema,
});

export const GetLaunchUrlResponseSchema = z.object({
  url: z.string(),
});
